import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BiLinkExternal } from "react-icons/bi";
import "./MemberCard.css";

export function getGraduationYear(entry) {
    if (entry.graduationYear) return String(entry.graduationYear);
    if (/present|now|current|至今|在读/i.test(entry.period || "")) return "";
    const years = (entry.period || "").match(/\b(?:19|20)\d{2}\b/g) || [];
    return years.length >= 2 ? years[years.length - 1] : "";
}

export function formatEducation(entry) {
    let degree = (entry.degree || "").replace(/\s+in\s+.*$/i, "").trim();
    if (/^bachelor(?:['’]s)?(?: degree)?$/i.test(degree)) degree = "Bachelor's Degree";
    if (/^master(?:['’]s)?(?: degree)?$/i.test(degree)) degree = "Master's Degree";
    const year = getGraduationYear(entry);
    return entry.institution + (degree ? ", " + degree : "") + (year ? " (" + year + ")" : "");
}

function MemberCard({ member }) {
    const education = [...new Set(member.education
        .filter((entry) => entry.showOnCard !== false && entry.institution)
        .slice()
        .sort((a, b) => Number(getGraduationYear(b)) - Number(getGraduationYear(a)))
        .map(formatEducation))];

    return (
        <Card className="project-card-view member-card">
            {member.avatar && (member.photoMode === "original" ? (
                <Card.Img variant="top" src={member.avatar} alt={member.name} />
            ) : (
                <div className={member.photoMode === "contain"
                    ? "member-card-portrait member-card-portrait--contain"
                    : "member-card-portrait"}>
                    <Card.Img variant="top" src={member.avatar} alt={member.name} />
                </div>
            ))}
            <Card.Body>
                <Card.Title>{member.name}</Card.Title>
                {member.role && <Card.Text style={{ textAlign: "left", whiteSpace: "pre-line" }}>{member.role}</Card.Text>}
                {(education.length > 0 || member.email) && (
                    <dl className="member-card-details">
                        {education.length > 0 && (
                            <>
                                <dt>Education Background</dt>
                                <dd>{education.map((entry) => <div key={entry}>{entry}</div>)}</dd>
                            </>
                        )}
                        {member.email && (
                            <>
                                <dt>Email</dt>
                                <dd><a href={`mailto:${member.email}`}>{member.email}</a></dd>
                            </>
                        )}
                    </dl>
                )}
                <Button variant="primary" href={member.path} target="_blank" rel="noopener noreferrer">
                    <BiLinkExternal /> &nbsp;Learn more
                </Button>
            </Card.Body>
        </Card>
    );
}

export default MemberCard;
